var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H3.5V3.5H0.5V0.5Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5H9.5V3.5H6.5V0.5Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H15.5V3.5H12.5V0.5Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5H3.5V9.5H0.5V6.5Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5H9.5V9.5H6.5V6.5Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.5H15.5V9.5H12.5V6.5Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.5H3.5V15.5H0.5V12.5Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.5H9.5V15.5H6.5V12.5Z",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5H15.5V15.5H12.5V12.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIconSelected);
export default __webpack_public_path__ + "static/media/gridIconSelected.2dc22a69f73f9db1e336f92cfd1f1e18.svg";
export { ForwardRef as ReactComponent };